/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { mercuryBaseQuery } from 'api/base'

/**********************************************************************************************************
  *   ACCOUNT API
  **********************************************************************************************************/
export const supportAPI = createApi({
    reducerPath: 'supportAPI',
    baseQuery: mercuryBaseQuery,
    endpoints: (builder) => ({
        supportRequest: builder.mutation({
            query: (body) => ({
                url: 'client/support',
                method: 'POST',
                body
            })
        })
    })
})

export const {
    useSupportRequestMutation
} = supportAPI
